import { useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "course_deadline_closed";

function readStored(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

function writeStored(value: boolean): void {
  try {
    if (value) {
      localStorage.setItem(STORAGE_KEY, "true");
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // storage unavailable, ignore
  }
}

export default function useDeadlineOverride() {
  const [isManuallyClosed, setIsManuallyClosed] = useState<boolean>(readStored);

  useEffect(() => {
    const onStorage = () => setIsManuallyClosed(readStored());
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const setManualClose = useCallback((closed: boolean) => {
    writeStored(closed);
    setIsManuallyClosed(closed);
  }, []);

  return { isManuallyClosed, setManualClose };
}